import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import sessionStorage from 'app/services/session';
import Success from './Success.component';

const mapStateToProps = () => ({
  clearSession: () => sessionStorage.clear()
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    null
  )
)(Success);
